// @flow
import * as React from 'react';
import {BodyMono} from 'sail/Text';
import type {InputCommand} from './terminal/command';
import {Stripe} from './executables/stripe';

const executables = {
  stripe: Stripe,
};

export function execute(
  command: InputCommand,
  apiKey: string,
  setAllowInput: (boolean) => void,
) {
  if (command.executable === null || command.executable === '') {
    setAllowInput(true);
    return '';
  }

  // The command is not in the executable list above
  // todo(tomer): add top-level `help` executable
  if (!(command.executable in executables)) {
    setAllowInput(true);
    return <BodyMono>command not found: {command.executable}</BodyMono>;
  }

  const executable = new executables[command.executable](
    command,
    setAllowInput,
  );

  if (command.isHelp) {
    return (
      <BodyMono color="gray200" style={{whiteSpace: 'pre-wrap'}}>
        {executable.help()}
      </BodyMono>
    );
  }

  return executable.run(apiKey);
}
